import { StorageIds } from '../constants/storage'

export const getStorageSettings = () => {
  return localStorage.getItem(StorageIds.settings) || ''
}
